// extracted by mini-css-extract-plugin
export default {"ArchiveTable":"ArchivedTickets_ArchiveTable__dilU4","ButtonContainer":"ArchivedTickets_ButtonContainer__3-Uau","mainFileView":"ArchivedTickets_mainFileView__Ff2qT"};